import view from './list.vue'
import edit from './edit.vue'
export default {
	view,
	edit
}